import request from '@/utils/request'

let BonusApi = {
  getGradeList(data, errorback) {
    return request._get('/shop/data.user/grade', data, errorback);
  },
  /*结算单列表*/
  getList(data, errorback) {
    return request._get('/shop/weightbonus.bonus/index', data, errorback);
  },
  /*创建结算单*/
  add(data, errorback) {
    return request._post('/shop/weightbonus.bonus/add', data, errorback);
  },
  /*删除结算单*/
  del(data, errorback) {
    return request._post('/shop/weightbonus.bonus/delete', data, errorback);
  },
   /*获取结算单*/
   getSettlement(data, errorback) {
    return request._get('/shop/weightbonus.bonus/detail', data, errorback);
  },

  /*获取结算单详情*/
  getSettlementLogList(data, errorback) {
    return request._get('/shop/weightbonus.settlement/index', data, errorback);
  },
 //确认结算单
 sendSettlement(data, errorback) {
    return request._post('/shop/weightbonus.bonus/send', data, errorback);
  },

}
export default BonusApi;



// WEBPACK FOOTER //
// ./src/api/weightbonus.js